import React from "react";
import Button from "components/Button/Button";
import { IconClose } from "icons";
import { ImageWebinar } from "images";
import { useDispatch } from "react-redux";
import { useAppSelector } from "store";
import { toggleWebinarModal } from "store/commonSlice";
import { useIsMobile } from "hooks/useIsMobile";

const WebinarModal = () => {
  const dispatch = useDispatch();
  const { showWebinarModal } = useAppSelector((state) => state.common);
  const isMobile = useIsMobile();

  function handleOnClose() {
    dispatch(toggleWebinarModal());
  }

  if (!showWebinarModal || isMobile) {
    return null;
  }

  return (
    <div className="fixed bottom-5 right-5 z-50 w-[360px] bg-white rounded-2xl border border-grey-light shadow-lg overflow-hidden">
      <div className="relative">
        <img src={ImageWebinar} alt="Webinar" className="w-full h-[160px] object-cover" />
        <button onClick={handleOnClose} className="absolute top-2.5 right-2.5 flex items-center justify-center w-7 h-7">
          <IconClose className="w-5 h-5 text-white" />
        </button>
      </div>
      <div className="flex gap-2 p-3">
        <Button className="btn-primary flex-1 flex items-center justify-center gap-1.5" onClick={() => window.open("https://us06web.zoom.us/j/81791255381", "_blank")}>
          <span className="fi fi-gb" /> Join in English
        </Button>
        <Button className="btn-primary flex-1 flex items-center justify-center gap-1.5" onClick={() => window.open("https://us06web.zoom.us/j/88226937574", "_blank")}>
          <span className="fi fi-tr" /> Türkçe Katıl
        </Button>
      </div>
    </div>
  );
};

export default WebinarModal;
